import { AgentCreate } from '../components/agent';
import { LeftNav } from '../components/nav';

export default function Create() {
  return (
    <LeftNav>
      <AgentCreate />
    </LeftNav>
  );
}
